import { IEntity } from '../interfaces/entity';
import { ReferralSource } from './referral-source';

export interface IReferralList{
  items: Referral[];
  totalCount: number;
}

// tslint:disable-next-line: max-classes-per-file
export class ReferralComment{
  id: number;
  uid: string;
  referralId: number;
  dateTimeAdded: string;
  addedBy: string;
  comment: string;
  private: boolean;

  constructor(comment?){
    comment = comment || {};
    this.id = comment.id;
    this.uid = comment.uid;
    this.referralId = comment.referrralId;
    this.dateTimeAdded = comment.dateTimeAdded;
    this.addedBy = comment.addedBy;
    this.comment = comment.comment;
    this.private = comment.private;
  }
}

// tslint:disable-next-line: max-classes-per-file
export class Referral implements IEntity {
  id: number;
  uid: string;
  referralDate: string;
  summary: string;
  referrerName: string;
  referrerTelephone: string;
  referrerEmail: string;
  managerName: string;
  managerTelephone: string;
  managerEmail: string;
  referralSourceId: number;
  referralSource: ReferralSource;
  canDelete: boolean;
  reportJson: any;
  referralComments: ReferralComment[];

  constructor(referral?){
    referral = referral || {};
    this.id = referral.id;
    this.uid = referral.uid;
    this.referralDate = referral.referralDate;
    this.referrerName = referral.referrerName;
    this.referrerTelephone = referral.referrerTelephone;
    this.referrerEmail = referral.referrerEmail;
    this.managerName = referral.managerName;
    this.managerTelephone = referral.managerTelephone;
    this.managerEmail = referral.managerEmail;
    this.referralSourceId = referral.referralSourceId;
    this.referralSource = referral.referralSource;
    this.reportJson = referral.reportJson;
    this.referralComments = referral.referralComments;
  }
}

// tslint:disable-next-line: max-classes-per-file
export class ReferralDataItem {
  name: string;
  value: string;
}

// tslint:disable-next-line: max-classes-per-file
export class ReferralData {
  data: ReferralDataItem[] | ReferralDataSection[];

  constructor(referralData?){
    referralData = referralData || {};
    this.data = referralData.data;
  }
}

// tslint:disable-next-line: max-classes-per-file
export class ReferralDataSection {
  name: string;
  fields: ReferralDataItem[];

  constructor(referralDataSection?){
    referralDataSection = referralDataSection || {};
    this.name = referralDataSection.name || '';
    this.fields = referralDataSection.fields;
  }
}
